import { Button } from "@mantine/core";
import styled from "styled-components";

export const StyledTR = styled.tr`
  .border-none {
    border: none;
  }

  .text-center {
    text-align: center;
  }

  .table-id {
    min-width: 150px;
  }

  .table-name {
    min-width: 300px;
  }

  .table-buttons {
    display: flex;
  }
`;

export const StyledButton = styled(Button)`
  margin-right: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-top: 0.5rem;
`;

export const StyledEditButton = styled(StyledButton)``;
